<template>
  <div class="input">
    <input
      v-model="value"
      class="form-control input__elem"
      placeholder="Отсутствует"
      :disabled="disabled"
      :maxlength="maxLength"
      @keypress="isNumber($event)"
      @input="$emit('input', $event.target.value)"
    />
    <button
      :disabled="disabled || !value"
      type="button"
      class="btn-primary input__button"
      @click="modalIsOpen = true"
    >
      {{ unitValue }}
    </button>
    <UnitModal
      v-if="modalIsOpen"
      :unit-value="unitValue"
      @close="modalIsOpen = false"
      @select="(value) => $emit('unit-select', value)"
    />
  </div>
</template>

<script>
import { useInputValidator } from '@/_shared/mixins';
import UnitModal from '@/stock/features/count-entity-units/UnitModal';
export default {
  mixins: [useInputValidator],
  components: {
    UnitModal,
  },
  props: {
    unitValue: {
      type: String,
      default: 'мм',
      validator(value) {
        return ['мм', 'м', 'см'].includes(value);
      },
    },
    maxlength: {
      type: Number,
      default: 300,
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'unit-select'],
  data() {
    return {
      modalIsOpen: false,
    };
  },
  computed: {
    possibleUnits() {
      return {
        millimeters: 'мм',
        centimeters: 'см',
        meters: 'м',
      };
    },
  },
};
</script>

<style scoped>
.input {
  display: flex;
  flex-direction: row;
}
.input__elem {
  width: 100%;
  margin-right: 0.5em;
}
.input__button {
  min-width: 34px;
  border: none;
}
.input__button:disabled {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/stock/features/count-entity-units/UnitInput.vue